function parseDateFromJSON(date) {
  if (!date) return "";
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i);
  if (!matches) return "";
  return matches[1] || "";
}

export interface BulkOrderCountModel {
  orderDate?: string;
  orderNumber?: string;
  ordered?: number;
  available?: number;
  quantity?: number;
}

export function bulkOrderCountModelFactory(json?: any): BulkOrderCountModel {
  json = json || {};
  return {
    orderNumber: json.orderNumber,
    orderDate: parseDateFromJSON(json.orderDate),
    ordered: +json.ordered,
    available: +json.available,
    quantity: +json.quantity,
  };
}
export function bulkOrderCountModelListFactory(json?: any): BulkOrderCountModel[] {
  return Array.from(json || []).map(bulkOrderCount => bulkOrderCountModelFactory(bulkOrderCount));
}
